import React from "react";
import { Button } from "antd";
import config from "./typeConfig";
import { i18n as i } from "@/i18n";
import { LinkProps } from "react-router-dom";
import "./exception.less";

interface ExceptionType {
  type: string;
  desc: string;
  style: any;
  linkElement: React.ForwardRefExoticComponent<
    LinkProps & React.RefAttributes<HTMLAnchorElement>
  >;
  className?: any;
  img: string;
  actions: any;
  title: string;
}

const Exception = (props: ExceptionType) => {
  const { type, title, desc, img, actions } = props;
  const pageType = type in config ? type : "404";
  return (
    <div className="exception">
      <div className="imgBlock">
        <div
          className="imgEle"
          style={{ backgroundImage: `url(${img || config[pageType].img})` }}
        />
      </div>
      <div className="content">
        <h1>{title || config[pageType].title}</h1>
        <div className="desc">{desc || config[pageType].desc}</div>
        <div className="actions">
          {actions || (
            <Button
              type="primary"
              onClick={() => {
                window.location.href = "/";
              }}
            >
              {i("返回首页")}
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default Exception;
